/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Card_Data_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add a missing card or fix a typo" |
*
* @param {Layout_Header_Card_Data_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_card_data_description = /** @type {((inputs?: Layout_Header_Card_Data_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Card_Data_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlende Karte ergänzen oder Tippfehler beheben")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajoutez une carte manquante ou corrigez une coquille")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("添加缺失的卡牌或修正错别字")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("新增缺少的卡牌或修正錯字")
	if (locale === "ko") return /** @type {LocalizedString} */ ("빠진 카드를 추가하거나 오타를 수정")
	return /** @type {LocalizedString} */ ("Add a missing card or fix a typo")
});